/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Toast_Validation_FailedInputs */



/**
* | output |
* | --- |
* | "We could not verify the API key. Please check it and try again." |
*
* @param {Integrations_Toast_Validation_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_toast_validation_failed = /** @type {((inputs?: Integrations_Toast_Validation_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Toast_Validation_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der API-Schlüssel konnte nicht überprüft werden. Bitte prüfen Sie ihn und versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("We could not verify the API key. Please check it and try again.")
});